import * as React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import Header from './header';
import Footer from './footer';
import './layout.css';

const Layout = ({ children }: { children: React.ReactNode }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={(data) => (
      <div className="flex flex-col  min-h-screen">
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content: 'Starter4Ten Ltd Consulting',
            },
            {
              name: 'keywords',
              content:
                'Programming, Consulting, Agile, Software Engineering, Software Development, Coaching',
            },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header />
        <main className="flex-1 flex flex-col">{children}</main>
        <Footer />
      </div>
    )}
  />
);

export default Layout;
